import React from 'react'
import '@fortawesome/fontawesome-free/css/all.css'
import SidebarItem from './SidebarItem'
import { withRouter } from 'react-router-dom'

const Sidebar = (props) => {
  const { menus, mesesAConfigurar, toggleSidebar, requestAcoes, location, mobileSidebarOpen, onCloseMobile } = props
  const visibleMenus = mesesAConfigurar && mesesAConfigurar.length > 0 ? [] : menus

  const sidebarClass = [
    'sidebar',
    toggleSidebar ? 'sidebar-toggle' : '',
    mobileSidebarOpen ? 'sidebar--mobile-open' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={sidebarClass}>
      <ul className='list-unstyled mb-0'>
        {visibleMenus.map((menu) => (
          <SidebarItem
            key={menu.id}
            item={menu}
            requestAcoes={requestAcoes}
            rotaAtual={location.pathname}
            onNavigate={onCloseMobile}
          />
        ))}
      </ul>
    </div>
  )
}

export default withRouter(Sidebar)
